// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  finger_url: "https://finger-sdk.verxid.site",
  //finger_url: "http://k8s-pro-identyfi-df11a00d1d-319063549.eu-west-2.elb.amazonaws.com",
  license:
    "QUVTAgAAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACEC7ZOcb6kpM+MmW3WWo4qSs2/WThVMvUjgUOlD4Sig5glK7Se/XfXtdZqJanTXwZujxp1qgOUHC5UiRFhMtaBit7ajybE4I1rVN3c+ouZFyWPicyJoJUJL1zSxUCgMhqsMoN8V9GLYfFmQQzAjaooBGXswEeiADeSBtQgdaih2hvOsootLQoiLy+se89+TE5T",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
